export default function registerGlobalComponents(app) {
    const requireComponent = require.context(
        '.',      // 当前目录
        false,    // 不递归子目录
        /\.vue$/  // 只匹配 .vue 文件
    )
    requireComponent.keys().forEach(fileName => {
        const componentConfig = requireComponent(fileName)
        const componentName = fileName
            .replace(/^\.\//, '')
            .replace(/\.\w+$/, '')

        app.component(componentName, componentConfig.default || componentConfig)
    })
}